module.exports = __webpack_public_path__ + "img/cotImage.b23de277.svg";